/**
 * Media Configuration
 * Centralized configuration for all media assets (videos, audio, etc.)
 */

// Category Videos for product pages
export const CATEGORY_VIDEOS = {
  'Modular Office Workstation': 'https://customer-assets.emergentagent.com/job_modfurnizone/artifacts/s1fak9pr_Animation%202.mp4',
  'Storage Cabinets': 'https://customer-assets.emergentagent.com/job_modfurnizone/artifacts/088gbt3g_media%20%282%29.mp4',
  'Privacy Booths': 'https://customer-assets.emergentagent.com/job_modfurnizone/artifacts/6enstupv_WhatsApp%20Video%202025-12-04%20at%2013.42.10_6f220a48.mp4'
};

// Audio files for Noise Check feature
export const NOISE_CHECK_AUDIO = {
  inside: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/qcakvvf4_Murmuring%20Sound%20Inside.mp4',
  outside: 'https://customer-assets.emergentagent.com/job_2d903c81-e1a2-44f8-82cd-4f49b52d8c19/artifacts/q6ckjtjk_Murmuring%20Sound%20Outside.mp4'
};

// Helper function to get category video
export function getCategoryVideo(category) {
  return CATEGORY_VIDEOS[category] || null;
}

// Category names mapped to display names
export const CATEGORY_DISPLAY_NAMES = {
  'Modular Office Workstation': 'MODULAR WORKSTATIONS',
  'Storage Cabinets': 'STORAGE SOLUTIONS',
  'Privacy Booths': 'PRIVACY BOOTHS'
};
